import React, { useState, lazy, Suspense } from 'react';
import { Container, Tab, Header, Loader, Segment } from 'semantic-ui-react';

// 懒加载子组件
const AppManagement = lazy(() => import('../App'));
const DeviceManagement = lazy(() => import('../Device'));
const ExecutionManagement = lazy(() => import('../Execution'));

const LoadingFallback = () => (
  <Segment basic style={{ minHeight: 300 }}>
    <Loader active inline="centered">加载中...</Loader>
  </Segment>
);

const DataCollection = () => {
  const [activeIndex, setActiveIndex] = useState(0);

  const panes = [
    {
      menuItem: { key: 'app', icon: 'mobile alternate', content: 'App管理' },
      render: () => (
        <Tab.Pane attached={false}>
          <Suspense fallback={<LoadingFallback />}>
            <AppManagement />
          </Suspense>
        </Tab.Pane>
      ),
    },
    {
      menuItem: { key: 'device', icon: 'computer', content: '设备管理' },
      render: () => (
        <Tab.Pane attached={false}>
          <Suspense fallback={<LoadingFallback />}>
            <DeviceManagement />
          </Suspense>
        </Tab.Pane>
      ),
    },
    {
      menuItem: { key: 'execution', icon: 'code', content: '执行管理' },
      render: () => (
        <Tab.Pane attached={false}>
          <Suspense fallback={<LoadingFallback />}>
            <ExecutionManagement />
          </Suspense>
        </Tab.Pane>
      ),
    },
  ];

  return (
    <Container style={{ marginTop: '2em', marginBottom: '2em' }}>
      <Header as="h1" style={{ marginBottom: '1.5em' }}>
        📦 数据收集
        <Header.Subheader style={{ marginTop: '0.5em' }}>
          管理应用、设备和执行记录
        </Header.Subheader>
      </Header>

      <Tab 
        panes={panes} 
        activeIndex={activeIndex}
        onTabChange={(e, { activeIndex }) => setActiveIndex(activeIndex)}
        menu={{ secondary: true, pointing: true }}
      />
    </Container>
  );
};

export default DataCollection;

